import {createPermissionRules} from 'utils/permissionRules'

const actions = {
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  READ: 'read',
}

const resources = {
  DASHBOARD: 'dashboard',
  BUSINESSGROUP: 'businessgroup',
}

/**
 *
 * @param {resources} _resources all permission resources {PROMOTIONS: 'promotions', STORES: 'stores'}
 * @param {actions} _actions all action CRUD {READ: 'read', delete: 'delet', ...}
 * @returns Object with rule permission constants in format ej: {READ_PROMOTIONS: 'read.promotions', DELETE_PROMO...}
 * Auto generate permission constants based on resource and action. action CREATE + resource PROMOTION = CREATE_PROMOTION
 */
const autoGeneratePermissionConstants = (_resources, _actions) => {
  const constantSymbol = '_'
  const rulePermissions = {}

  Object.keys(_resources).forEach(resource => {
    Object.keys(_actions).forEach(action => {
      const rule = createPermissionRules({resource, action})
      const key = rule.replace('.', constantSymbol).toUpperCase()

      rulePermissions[key] = rule
    })
  })

  return rulePermissions
}

export default autoGeneratePermissionConstants(resources, actions)
